import { createApi as createUnsplashApi } from "unsplash-js";

// eslint-disable-next-line import/prefer-default-export
export const copywriting = {
  TITLE: "Choose background",
  FORM_INVALID: "Please select an image to save",
  FORM_SAVE_ERROR: "We're having issues saving the image, please try again",
  RESULTS_PLACEHOLDER: "No images found",
  RESULTS_LOADING: "Loading...",
  SEARCH_ERROR:
    "We're having retrieving images from Unsplash, please try again",
  LOADMORE_ERROR:
    "There was an error loading more results, please try searching again",
  ATTRIBUTION_LABEL: "Photos by Unsplash",
  SEARCH_PLACEHOLDER: "Start typing to search",
};

export const sizing = {
  MODAL_HEIGHT: "80vh",
  MODAL_WIDTH: "90vw",
  MODAL_MAXHEIGHT: "90vh",
  MODAL_MAXWIDTH: "90vw",
  CARD_WIDTH: 190,
  CARD_GUTTER: 8,
  CARD_LABEL_HEIGHT: 30,
};

export const SEARCH_LIMIT = 20;

export const unsplash = createUnsplashApi({
  accessKey: process.env.REACT_APP_UNSPLASH_ACCESS_KEY,
});
